import { FormControl, InputLabel, MenuItem, Select, SelectChangeEvent } from "@mui/material";
import CascateList from "../../../../../../common/components/cascate_list";
import { useCallback } from "react";
import PrimaryButton from "../../../../../../common/components/primary_button";
import DynamicIcon from "../../../../../../common/components/dynamic_icon";
import { DefaultDataCronogramaSGQ } from "../../../../../../common/components/default_data_prevista_CronogramaSGQ";
import DefaultInput from "../../../../../../common/components/default_input";
import { DefaultDataProvisaoRecurso } from "../../../../../../common/components/default_data_provisao_recurso";

// Header 

type Props = {
  pesquisa: string  | null,
  onClearFilters: () => void;
  handlePesquisa: (v: string | null) => void,
};

export const Header = ({ pesquisa, handlePesquisa, onClearFilters }: Props) => {
  
  const handleClearFilters = useCallback(() => {
    onClearFilters();
  }, [onClearFilters]);

  return (
    <CascateList title="Filtros" defaultOpen>
      <div className="w-full flex flex-col gap-6">
        <div className="w-full">
          <div className="w-1/2 mb-4">
            <DefaultInput label="Ano" name="search_by_ano" value={pesquisa ?? ""} onChangeValue={handlePesquisa}/>
          </div>
          {/* Botão Limpar */}
          <div className="w-full flex justify-end md:col-span-3">
            <div className="w-full md:w-[180px]">
              <PrimaryButton
                startIcon={<DynamicIcon nameIcon="ClearRounded" size={25} className="text-black" />}
                buttonColor="yellow"
                onClick={handleClearFilters}>
                Limpar filtros
              </PrimaryButton>
            </div>
          </div>
        </div>
      </div>
    </CascateList>
  );
}